import { Moment } from 'moment';
import { WorkOrderComplementType } from '../WorkOrdersComplements/WorkOrdersComplements.types';

export type ChartData = Record<string, Record<string, number>>;

export type DefaultParamsRequest = {
  startDate: string;
  endDate: string;
  companiesIds?: number[];
};

export type AverageTicketFormValues = {
  types: WorkOrderComplementType;
  dates: [Moment, Moment];
  companiesIds?: number[];
};

export type AverageTicketParams = {
  types: WorkOrderComplementType;
  startDate: string;
  endDate: string;
  companiesIds?: number[];
};

export type ExpenseIncomeFormValues = {
  dates: [Moment, Moment];
  companiesIds?: number[];
};

export type ExpensesIncomeParams = {
  startDate: string;
  endDate: string;
  companiesIds?: number[];
};

export enum PartsServicesStatus {
  open = 'domain.enums.work_order_status.open',
  authorized = 'domain.enums.work_order_status.authorized',
  closed = 'domain.enums.work_order_status.closed',
  cancelled = 'domain.enums.work_order_status.cancelled',
}

export type PartsServicesFormValues = {
  dates: [Moment, Moment];
  companiesIds?: number[];
  status?: PartsServicesStatus[];
};

export interface PartsServicesParams extends DefaultParamsRequest {
  status?: PartsServicesStatus[];
}

export enum CashFlowType {
  period = 'domain.enums.cash_flow_type.period',
  weekly = 'domain.enums.cash_flow_type.weekly',
}

export enum CashFlowDateType {
  emissionDate = 'domain.enums.date_type.emissiondate',
  payDate = 'domain.enums.date_type.paydate',
  dueDate = 'domain.enums.date_type.duedate',
}

export enum CashFlowSituation {
  open = 'domain.enums.situation_type.open',
  settled = 'domain.enums.situation_type.settled',
}

export type CashFlowParams = {
  initialDate: string;
  type: CashFlowType;
  dateType?: CashFlowDateType;
  situation?: CashFlowSituation[];
  bankAccountIds?: number[];
  companyIds?: number[];
};

export interface CostFixedVariableFormValues {
  startDate: Moment;
  endDate: Moment;
  companiesIds: number[];
}

export type CostFixedVariableParams = DefaultParamsRequest;

export interface ComparasionInsurersFormValues {
  startDate: Moment;
  endDate: Moment;
  companiesIds: number[];
  insurersIds: number[];
  managementChartType: number;
}

export type ComparasionInsurersParams = DefaultParamsRequest & {
  insurersIds?: number[];
  managementChartType: number;
};

export type CostSalesFormValues = Omit<
  DefaultParamsRequest,
  'startDate' | 'endDate'
> & {
  startDate: Moment;
  endDate: Moment;
  companiesIds: number[];
  types: WorkOrderComplementType[];
};

export type CostSalesParams = DefaultParamsRequest & {
  types: WorkOrderComplementType[];
};

export type BillingOverviewFormValues = {
  startDate: Moment;
  endDate: Moment;
  companiesIds: number[];
};

export type BillingOverviewParams = DefaultParamsRequest;

export type BillingPassAverageTicketFormValues = {
  startDate: Moment;
  endDate: Moment;
  companiesIds: number[];
};

export type BillingPassAverageTicketParams = DefaultParamsRequest;

export interface BillingExpenseRevenueFormValues {
  companiesIds: number[];
  displayOverdueExpenses: boolean;
  displayOverdueReceipts: boolean;
  startDate: Moment;
  endDate: Moment;
}

export type BillingExpenseRevenueParams = DefaultParamsRequest & {
  displayOverdueExpenses?: boolean;
  displayOverdueReceipts?: boolean;
};

/** Vai receber um objeto que a propriedade dele é uma string,
 * e o valor é um objeto e esse objeto as propriedades dele é uma string e o valor é numerico */
export type ChartResponse = {
  chartData: ChartData;
};
